var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { k } from "@/utilities/i18n";
import translate from "@/utilities/i18n/getTranslate";
import { ExperienceTypeEnum, ImplementOnboardingFlowEnum, } from "../PartnerInitialOnboardingTypes";
var supportTitle = {
    title: translate(k.FN_getSupport),
    description: translate(k.FN_chooseHowToConnect),
};
export var registerNumberSteps = function (selectedIOFlow, selectedExperience) {
    return __spreadArray(__spreadArray([
        {
            title: translate(k.FN_chooseExperience),
            description: translate(k.FN_chooseExperienceDesc),
        }
    ], __read((selectedExperience === ExperienceTypeEnum.GUIDED_SUPPORT
        ? [supportTitle]
        : [])), false), [
        {
            title: translate(k.FN_choosePath),
            description: translate(k.FN_preferredFlow),
        },
        {
            title: translate(k.FN_implementOnboarding),
            description: translate(k.FN_implementOnboardingDesc),
        },
        selectedIOFlow === ImplementOnboardingFlowEnum.DIRECT_LINK
            ? {
                title: translate(k.FN_directLinkSetup),
                description: translate(k.FN_shareLinkWithClient),
            }
            : selectedIOFlow === ImplementOnboardingFlowEnum.CONNECT_BUTTON
                ? {
                    title: translate(k.FN_connectButtonSetup),
                    description: translate(k.FN_useNpmPackage),
                }
                : {
                    title: translate(k.FN_selfHostedEmbed),
                    description: translate(k.FN_fullCustomizationNote),
                },
        {
            title: translate(k.FN_registerFirstNum),
            description: translate(k.FN_readyToRegisterDesc),
        },
    ], false);
};
export var quickRegistrationSteps = function (selectedExperience) { return __spreadArray(__spreadArray([
    {
        title: translate(k.FN_chooseExperience),
        description: translate(k.FN_chooseExperienceDesc),
    }
], __read((selectedExperience === ExperienceTypeEnum.GUIDED_SUPPORT
    ? [supportTitle]
    : [])), false), [
    {
        title: translate(k.FN_choosePath),
        description: translate(k.FN_preferredFlow),
    },
    {
        title: translate(k.FN_simpleRegistration),
        description: translate(k.FN_registerFirstNumDescSimple),
    },
], false); };
//# sourceMappingURL=data:application/json;base64,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